import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheck, MapPin, Quote } from "lucide-react";
import { SPOTLIGHT_PARTNERS } from "../lib/network";

const CAT_COLORS = {
  "Elite Super Stockist": "#E8C15A",
  "Super Stockist": "#B87333",
  "Wholesaler": "#2FB999",
  "Dealer": "#5B8DEF",
  "Booking Agent": "#D8B23E",
  "Civil Contractor": "#C0654E",
  "Supplier": "#9B7BD8",
};

export const PartnerSpotlight = () => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((p) => (p + 1) % SPOTLIGHT_PARTNERS.length), 3800);
    return () => clearInterval(t);
  }, [paused]);

  const p = SPOTLIGHT_PARTNERS[i];

  return (
    <div
      data-testid="partner-spotlight"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      className="relative border border-white/10 rounded-sm bg-white/[0.02] p-7 md:p-8 overflow-hidden min-h-[240px] flex flex-col"
    >
      <div className="flex items-center justify-between">
        <span className="overline text-[#B87333]">/ Partner spotlight</span>
        <Quote size={18} className="text-[#B87333]/50" />
      </div>

      <div className="relative flex-1 mt-5">
        <AnimatePresence mode="wait">
          <motion.div
            key={p.id}
            data-testid="spotlight-card"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="flex items-center gap-2">
              <span className="font-serif text-2xl md:text-3xl text-[#F5F5F0] leading-tight">{p.name}</span>
              {p.verified && <BadgeCheck size={18} className="text-[#2FB999] shrink-0" />}
            </div>
            <div className="flex items-center gap-1.5 font-body text-sm text-[#8A8A82] mt-2">
              <MapPin size={13} /> {p.city}, {p.state}
            </div>
            <div className="flex items-center gap-3 mt-5">
              <span
                className="font-grotesk text-[10px] uppercase tracking-[0.16em] px-3 py-1 rounded-full"
                style={{ color: CAT_COLORS[p.category], border: `1px solid ${CAT_COLORS[p.category]}44` }}
              >
                {p.category}
              </span>
              <span className="font-body text-xs text-[#6f6f68]">Trusted partner since {p.since}</span>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* progress dots */}
      <div className="flex items-center gap-1.5 mt-6">
        {SPOTLIGHT_PARTNERS.map((_, k) => (
          <button
            key={k}
            data-testid={`spotlight-dot-${k}`}
            onClick={() => setI(k)}
            className={`h-1 rounded-full transition-all ${k === i ? "w-6 bg-[#B87333]" : "w-2 bg-white/15 hover:bg-white/30"}`}
            aria-label={`Show partner ${k + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
